// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_fH","advertDetailHeaderPrice__value":"c-m_fJ","advertDetailHeaderPrice__label":"c-m_fK"};